import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { Field } from 'redux-form';
import FormSelect from '../../form/FormSelect/FormSelect';

const Select = props =>
  <div className="form-dropdown">
    <Field
      label={props.label}
      id={props.id}
      name={props.name}
      component={FormSelect}
    >
      {map(props.items, item => (
        <option key={item.id} value={item.value}>{item.name}</option>
      ))}
    </Field>
  </div>;

Select.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string
};

export default Select;



/** WEBPACK FOOTER **
 ** ./src/components/ContactUs/Select/Select.js
 **/